import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { CreateProjectDto, ProjectDto } from '../types';

export const useCreateProject = () => {
  const queryClient = useQueryClient();

  return useMutation<ProjectDto, Error, CreateProjectDto>({
    mutationFn: (data) => apiClient.post('/v1/projects', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['projects'] });
    },
  });
};
